import { useEffect, useState } from "react";
import { useSearchParams, useNavigate, useParams } from "react-router-dom";

import MainFooter from "../components/MainFooter";

import eventShareIcon from "../ui-assets/home/share.svg";
import eventBackcardIcon from "../ui-assets/home/event-back-date-icon.svg";

import "../styles/NewHome.css";
import { API_BASE_URL } from "../config";
import { toast } from "react-toastify";

const ShareModal = ({ eventId, onClose }) => {
  const [copied, setCopied] = useState(false);

  const baseUrl = window.location.origin;
  const eventLink = `${baseUrl}/eventpage/${eventId}`;

  const handleCopy = () => {
    navigator.clipboard.writeText(eventLink).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2500);
    });
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="pshare-modal-overlay" onClick={handleBackdropClick}>
      <div className="share-modal">
        <div className="share-modal-header">
          <h5 className="share-modal-title">Share event link</h5>
          <button
            className="share-modal-close"
            onClick={onClose}
            aria-label="Close"
          >
            &times;
          </button>
        </div>
        <div className="share-modal-body">
          <div className="share-modal-input-row">
            <input
              type="text"
              className="share-modal-input"
              value={eventLink}
              readOnly
            />
            <button
              className={`share-modal-copy-btn${copied ? " copied" : ""}`}
              onClick={handleCopy}
            >
              {copied ? "Copied!" : "Copy"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const CategoryEvent = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalPages, setTotalPages] = useState(1);
  const [shareEventId, setShareEventId] = useState(null);
  const navigate = useNavigate();

  const { event_type: rawEventType } = useParams();
  const event_type = decodeURIComponent(rawEventType || "");
  const [searchParams, setSearchParams] = useSearchParams();
  const page = Number(searchParams.get("page")) || 1;

  useEffect(() => {
    const token = localStorage.getItem("token");
    setLoading(true);

    fetch(
      `${API_BASE_URL}/events?page=${page}&npp=15&event_type=${encodeURIComponent(event_type)}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    )
      .then((res) => res.json())
      .then((data) => {
        console.log("CATEGORY EVENTS API 👉", data);
        setEvents(data?.result || []);
        setTotalPages(data?.total_pages || 1);
      })
      .catch((err) => {
        console.error("API Error ❌", err);
        setEvents([]);
      })
      .finally(() => setLoading(false));
  }, [page, event_type]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [page]);

  // ✅ Updated handleRegister with registration check
  const handleRegister = (event) => {
    if (!event?.metadata?.isAttendeeRegistrationOpen) {
      toast.info(
        event?.metadata?.attendeeRegistrationMsg || "Registration is currently closed"
      );
      return;
    }

    const eventId = event?.metadata?.event_id;
    navigate(`/free-event-register/event/${eventId}`);
  };

  
const handleEventPage = (event) => {
  const eventId = event?.metadata?.event_id;

  if (eventId) {
    window.open(
      `/eventpage/${eventId}`,
      "_blank",
      "noopener,noreferrer"
    );
  } else {
    toast.error("Event ID not found");
  }
};


  const handleShareClick = (e, event) => {
    e.stopPropagation();
    setShareEventId(event?.metadata?.event_id);
  };

  const formatEventDate = (start, end) => {
    if (!start || !end) return "";

    const startDate = new Date(start);
    const endDate = new Date(end);

    const sameMonth = startDate.getMonth() === endDate.getMonth();
    const sameYear = startDate.getFullYear() === endDate.getFullYear();

    const startStr = startDate.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
    });

    const endStr = endDate.toLocaleDateString("en-US", {
      month: sameMonth ? undefined : "short",
      day: "numeric",
      year: sameYear ? undefined : "numeric",
    });

    const yearStr = startDate.getFullYear();

    return `${startStr}–${endStr}, ${yearStr}`;
  };

  return (
    <div className="all-events-page">
      <section className="container upcoming-event-wrapperr">
       <div className="category-explore-heading">
  <span className="category-explore-accent"></span>

  <h2>
    Explore <span>{event_type}</span>
  </h2>
</div>

        {loading ? (
          <div style={{ textAlign: "center", padding: "30px 0" }}>
            Loading events...
          </div>
        ) : events.length === 0 ? (
          <div style={{ textAlign: "center", padding: "30px 0" }}>
            No events found...
          </div>
        ) : (
          <div className="product-grid">
            {events.map((event) => {
              // ✅ Console logs for debugging
              console.log("CATEGORY EVENTS ITEM =>", event);
              console.log("CATEGORY EVENTS METADATA =>", event.metadata);
              console.log("isAttendeeRegistrationOpen =>", event?.metadata?.isAttendeeRegistrationOpen);
              console.log("attendeeRegistrationMsg =>", event?.metadata?.attendeeRegistrationMsg);

              return (
                <div className="product-item" key={event.id}>
                  <div
                    className="flip-card"
                    onClick={() => handleEventPage(event)}
                  >
                    <div className="flip-card-inner">
                      {/* BACK */}
                      <div className="flip-card-back">
                        <div className="card-img-wrap">
                          {event?.banner_file?.base64 ? (
                            <img
                              src={event.banner_file.base64}
                              alt={event?.metadata?.name}
                            />
                          ) : (
                            <div className="card-img-placeholder">
                              <i className="fas fa-calendar-alt"></i>
                            </div>
                          )}

                          {event?.metadata?.event_type && (
                            <span className="card-event-type-badge">
                              {event.metadata.event_type}
                            </span>
                          )}
                        </div>

                        <div className="card-content">
                          <div className="card-meta-pills">
                            <span className="card-date-pill">
                              <img src={eventBackcardIcon} alt="" width="12" />
                              {formatEventDate(
                                event?.metadata?.start_date,
                                event?.metadata?.end_date
                              )}
                            </span>

                            <span className="card-city-pill">
                              {event?.metadata?.city}
                            </span>
                          </div>

                          <h4 className="card-title">
                            {event?.metadata?.name}
                          </h4>

                          {event?.metadata?.description && (
                            <p className="card-desc">
                              {event.metadata.description}
                            </p>
                          )}

                          {/* ✅ Updated button with registration open/close logic */}
                          <button
                            className={`card-register-btn ${
                              !event?.metadata?.isAttendeeRegistrationOpen
                                ? "disabled-btn"
                                : ""
                            }`}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleRegister(event);
                            }}
                          >
                            {event?.metadata?.isAttendeeRegistrationOpen
                              ? "Register Event"
                              : "Registration Closed"}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        <div className="number-pagination">
          {[...Array(totalPages)].map((_, i) => {
            const pageNumber = i + 1;
            const isActive = page === pageNumber;

            return (
              <button
                key={pageNumber}
                disabled={isActive}
                className={isActive ? "active" : ""}
                onClick={() => {
                  if (!isActive) {
                    setSearchParams({ page: pageNumber });
                  }
                }}
              >
                {pageNumber}
              </button>
            );
          })}
        </div>
      </section>

      {shareEventId && (
        <ShareModal
          eventId={shareEventId}
          onClose={() => setShareEventId(null)}
        />
      )}

      <MainFooter />
    </div>
  );
};

export default CategoryEvent;